import symbolLayout from "./symbol"

/**
 * Layout: Arabic
 */
const layout = {
  default: [
    "\u0630 1 2 3 4 5 6 7 8 9 0",
    "\u0636 \u0635 \u062B \u0642 \u0641 \u063A \u0639 \u0647 \u062E \u062D \u062C \u062F \\",
    "\u0634 \u0633 \u064A \u0628 \u0644 \u0627 \u062A \u0646 \u0645 \u0643 \u0637",
    "{shift} \u0626 \u0621 \u0624 \u0631 \u0644\u0627 \u0649 \u0629 \u0648 \u0632 \u0638 {bksp}",
    "{number} {lang} {space} {enter}",
  ],
  shift: [
    "\u0651 ! @ # $ % ^ & * ) ( _ +",
    "\u064E \u064B \u064F \u064C \u0644\u0625 \u0625 \u2018 \u00F7 \u00D7 \u061B < > |",
    '\u0650 \u064D ] [ \u0644\u0623 \u0623 \u0640 \u060C / : "',
    "{shift} ~ \u0652 } { \u0644\u0622 \u0622 \u2019 , . \u061F {bksp}",
    "{number} {lang} {space} {enter}",
  ],
  ...symbolLayout,
}

export const arabicKeyboardOptions = {
  layout,
  display: {
    "{lang}": "ARABIC",
    "{abc}": "العربية",
  },
  rtl: true,
}
